// we need to use export = to simulate default export for CommonJS format
// this file is the main entry point for CommonJS modules, the rest use main.ts
import Glue4Office from "./main";
export = Glue4Office;
